import { render, staticRenderFns } from "./WaysToSell.vue?vue&type=template&id=5b1e87bf&scoped=true&"
import script from "./WaysToSell.vue?vue&type=script&lang=js&"
export * from "./WaysToSell.vue?vue&type=script&lang=js&"
import style0 from "./WaysToSell.vue?vue&type=style&index=0&id=5b1e87bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e87bf",
  null
  
)

export default component.exports